/**
* @Author: zachalam
* @Date:   2017-02-17T16:24:19-08:00
* @Email:  zach@reflexmedia.com
* @Last modified by:   zachalam
* @Last modified time: 2017-02-17T16:24:19-08:00
*/


import * as sdk from '../sdk';
import { storeMeta } from './metaActions';

export const requestFavs = (payload) => {
  return {
    type: 'REQUEST_FAVS'
  }
}

export const storeFavs = (payload) => {
  return {
    type: 'STORE_FAVS',
    payload
  }
}

export const clearFavs = () => {
  return {
    type: 'CLEAR_FAVS'
  }
}

export const storeFavChange = (payload) => {
  return {
    type: 'STORE_FAV_CHANGE',
    payload
  }
}

export const storeProfileFavChange = () => {
  return {
    type: 'STORE_PROFILE_FAV_CHANGE'
  }
}

export const favToggleHome = (payload) => {
  return {
    type: 'STORE_FAV_CHANGE_HOME',
    payload
  }
}

export const refreshFavs = (type="to",firstCall=true,per_page=0) => {
  return(dispatch,getState) => {

    let pageToGet = 0;

    if(firstCall) { dispatch(clearFavs()); }
    else { pageToGet = getState().meta.fav_current_page+1;  }
    dispatch(requestFavs());

    if(type === "viewed") {
      // get "visited me" - viewed
      return sdk.getVisitedMe(getState().auth.jwToken,pageToGet)
                .then((response) => {
                  dispatch(storeFavs(response.data.data))
                  // store pagination
                  let page = response.data.meta.pagination;
                  dispatch(storeMeta({fav_current_page: page.current_page, fav_total_pages: page.total_pages}));

                })

    } else {
      // get "favorites" - to/from
      return sdk.getFavorites(getState().auth.jwToken, type,pageToGet,per_page)
                .then((response) => {
                  dispatch(storeFavs(response.data.data))
                  // store pagination
                  let page = response.data.meta.pagination;
                  dispatch(storeMeta({fav_current_page: page.current_page, fav_total_pages: page.total_pages}));

                })
    }

  }
}

export const favToggle = (username) => {
  // flip favorite status
  return (dispatch,getState) => {
    // notify api.
    return sdk.toggleFavorite(getState().auth.jwToken,username);
  }
}


// WEBPACK FOOTER //
// ./src/actions/favActions.js